import { render, staticRenderFns } from "./FinishedContestCard.vue?vue&type=template&id=569a972a"
import script from "./FinishedContestCard.vue?vue&type=script&lang=js"
export * from "./FinishedContestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports